export const HTTP_ERROR = {
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
} as const;

export type THttpErrorCode = (typeof HTTP_ERROR)[keyof typeof HTTP_ERROR];
